import React, { FC } from "react";
import SkeletonItem from "../../SkeletonItem/SkeletonItem";
import "./TableInfo.scss";
const TableInfo: FC<{
  icon: string;
  title: string;
  description?: string;
  cardDetails?: { title: string; amount: string | number }[];
}> = ({ description, icon, title, cardDetails }) => {
  return (
    <div className="table-info">
      <div className="table-info__icon-title">
        <div className="table-info__icon">
          <img src={icon} alt="tableIcon" />
        </div>
        <div className="table-info__text">
          <p className="table-info__title">{title}</p>
          {description && !description.includes("undefined") ? (
            <p className="table-info__description">{description}</p>
          ) : (
            <SkeletonItem width={140} height={30} borderRadius={8} />
          )}
        </div>
      </div>
      {cardDetails && (
        <div className="table-info__items">
          {cardDetails.map((detail, index) => {
            return (
              <div key={detail.title} className="table-info__detail-item">
                <div>
                  <p className="table-info__item-title">{detail.title}</p>
                  <p className="table-info__item-amount">{detail.amount}</p>
                </div>
                {index < cardDetails.length - 1 && (
                  <div className="table-info__separator" />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TableInfo;
